export * from './MedPillsIcon';
export * from './MedPillsIcon16Light';
export * from './MedPillsIcon16Regular';
export * from './MedPillsIcon16Solid';
export * from './MedPillsIcon20Light';
export * from './MedPillsIcon20Regular';
export * from './MedPillsIcon20Solid';
export * from './MedPillsIcon24Regular';
export * from './MedPillsIcon24Solid';
export * from './MedPillsIcon32Regular';
export * from './MedPillsIcon64Regular';
